// extracted by mini-css-extract-plugin
export default {"ordersList":"OrdersList_ordersList__5xTBM"};